<markant-select
  [formControl]="$any(control())"
  [label]="label()"
  [value]="control().value"
  [name]="name()"
  [placeholder]="placeholder()"
  [helper]="helper()"
  [error]="error()"
  [outlined]="outlined()"
  [multiselect]="multiselect()"
  [truncateOptions]="truncateOptions()"
  [searchable]="searchable()"
  [readonly]="readonly()"
  [options]="countries()"
  [required]="required()"
  [showLabelHint]="showLabelHint()"
  (valueChange)="valueChanged.emit($any($event.detail))"
>
</markant-select>
